import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import React from 'react';
import Modal from 'react-modal';
import { TransformWrapper, TransformComponent } from 'react-zoom-pan-pinch';

import closeSvg from '../../assets/img/close.svg';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  img: string;
}

export default function BigPictureModal({ isOpen, onClose, img }: Props) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="relative top-[10px] mx-auto w-full translate-y-[15vh] rounded-[24px] bg-[#FAF8F4] p-[16px] lg:w-2/6 lg:translate-y-[7vh]"
      overlayClassName="w-full fixed top-0 left-0 rigth-0 bottom-0 bg-[#0d0d0ccc]"
      closeTimeoutMS={300}
    >
      <TransformWrapper>
        {({ zoomIn, zoomOut }) => (
          <>
            <TransformComponent>
              <img src={img} alt="big picture" />
            </TransformComponent>
            <button
              className="absolute left-[10px] top-[10px] cursor-pointer rounded-[6px] border-[1px] border-[#d1cec7] bg-white p-[3px]"
              onClick={() => zoomIn()}
            >
              <ZoomInIcon />
            </button>
            <button
              className="absolute left-[10px] top-[50px] cursor-pointer rounded-[6px] border-[1px] border-[#d1cec7] bg-white p-[3px]"
              onClick={() => zoomOut()}
            >
              <ZoomOutIcon />
            </button>
          </>
        )}
      </TransformWrapper>
      <button
        className="absolute right-[10px] top-[10px] cursor-pointer rounded-[6px] border-[1px] border-[#d1cec7] bg-white p-[3px]"
        onClick={onClose}
      >
        <img src={closeSvg} alt="close" />
      </button>
    </Modal>
  );
}
